<template>
  <keep-alive>
    <router-view />
  </keep-alive>
</template>
<script>
import ds from "@/datastore";
export default {
  name: "UserDetails",
  props: ["id"],
  async activated() {
    let user = await ds.find("user", this.id);
    this.$store.commit("setTitle", "Пользователь " + user.name);
  },
  async deactivated() {
    this.$destroy();
  }
};
</script>
